export function createSimplePropAccessor(propName) {
  return {
    get() { return this[propName]; },
    set(v) { this.$emit(`update:${propName}`, v); }
  }
}

export function mapPropsToAccessors(propNames) {
  if (process.env.NODE_ENV !== 'production') {
    if (propNames.includes('value')) {
      console.warn('It is recommended to explicitly hande the `value` prop as this mapper emits a '
        + '`update:${propName}` event');
    }
  }

  const accessors = {};
  propNames.forEach(name => {
    accessors[`${name}Accessor`] = createSimplePropAccessor(name);
  });
  return accessors;
}

export default mapPropsToAccessors;
